export default "__VITE_ASSET__1LDk6p0d__"